<template>
    <ValidationObserver ref="observer" slim>
        <b-form @keyup.enter="save" @submit.prevent>
            <p class='subtitle'>
                {{$t(`pages.selfservice.forgotUsername.fuSubTitle`)}}
            </p>
            <b-form-group>
                <fr-floating-label-input v-model="mail" :validateRules="'required|email|max:130'" fieldName="mail" :label="$t('common.placeholders.emailAddress')" type="text" data-vv-validate-on="submit" ></fr-floating-label-input>
            </b-form-group>

            <fr-loading-button type="button"
                                :label="$t('common.form.submit')"
                                :loading="loading"
                                :large="true"
                                @click="submitForm"/>
            <!-- <div id="otp-div" class="" v-show="!isEmail" style="text-align:right;">
                <fr-loading-button type="button" variant="primary" class="w-50 d-inline-block buttondisp" style="display:inline-block!important;"
                                :label="$t('common.form.cancel')"
                                :large="true"
                                @click="$router.go(-1)"></fr-loading-button>
                <fr-loading-button type="button" variant="primary" class="w-50 d-inline-block buttondisp" style="display:inline-block!important;"
                                :label="$t('common.form.submit')"
                                :loading="loading"
                                :large="true"
                                @click="save"></fr-loading-button>
            </div> -->
            <Captcha v-if="selfServiceDetails.requirements.recaptcha" :self-service-details="selfServiceDetails" ref="recaptcha"></Captcha>
        </b-form>
    </ValidationObserver>
</template>

<script>
import FloatingLabelInput from '@/components/utils/FloatingLabelInput';
import LoadingButton from '@/components/utils/LoadingButton';
import InputValidations from '@/components/utils/mixins/InputValidationsMixin';
import Captcha from '../common/Captcha';
window.gaEvent('Forgot username', 'Forgot username', 'Render', 'page rendered.');
/**
 * @description Selfservice stage for multiple selfservice flows, typically used with an email to locate a user in the system to continue on with further
 * selfservice stages
 *
 **/
export default {
    name: 'User-Query',
    components: {
        'fr-floating-label-input': FloatingLabelInput,
        'fr-loading-button': LoadingButton,
        Captcha
    },
    props: {
        apiType: { required: true },
        selfServiceDetails: { required: true }
    },
    mixins: [
        InputValidations
    ],
    data () {
        return {
            mail: '',
            loading: false,
            recaptchaToken: undefined
        };
    },
    created () {
    },
    methods: {
        created () {
            this.customValidations();
        },
        getData () {
            return {
                queryFilter: `mail eq "${this.mail}"`,
                recaptchaToken: this.recaptchaToken
            };
        },
        submitForm () {
            if (this.selfServiceDetails.requirements.recaptcha) {
                this.$refs.recaptcha.executeScore('forgotUsername')
                    .then((token) => {
                        this.recaptchaToken = token;
                    }).catch((e) => {
                        console.log('Recaptcha error: ' + e);
                    }).finally(() => {
                        this.save();
                    });
            } else {
                this.save();
            }
        },
        save () {
            window.gaEvent('Forgot username', 'Forgot username', 'Submit', 'Submit button clicked.');
            this.isValid().then((valid) => {
                if (valid) {
                    this.loading = true;
                    window.gaEvent('Forgot username', 'Forgot username', 'Sent', 'Sent to backend.');
                    /* istanbul ignore next */
                    this.$emit('advanceStage', this.getData());
                }
            });
        },
        isValid () {
            /* istanbul ignore next */
            return this.$refs.observer.validate();
        }
    }
};
</script>
<style scoped lang="scss">
.subtitle {
    font-size: 14px;
    margin-bottom: 15px;
    line-height: 23px;
    font-family: 'Open Sans Complete', sans-serif;
    color: black;
    margin-top: -13px;
}
.text-danger {
    font-size: 14px !important;
    font-family: 'Open Sans', sans-serif !important;
}

.form-group {
    margin: initial;
}
</style>
